import { computed, onBeforeUnmount, ref, watch } from 'vue';

export const useEditorHistory = (read, restore) => {
  const entries = ref([read()]);
  const index = ref(0);
  let timer;
  let restoring = false;
  let grouping = false;
  const commit = () => {
    clearTimeout(timer);
    const current = read();
    if (current === entries.value[index.value]) return;
    entries.value = [...entries.value.slice(0, index.value + 1), current].slice(
      -100
    );
    index.value = entries.value.length - 1;
  };
  watch(
    read,
    () => {
      if (restoring || grouping) return;
      clearTimeout(timer);
      timer = setTimeout(commit, 500);
    },
    { flush: 'sync' }
  );
  const apply = target => {
    restoring = true;
    index.value = target;
    restore(entries.value[target]);
    restoring = false;
  };
  const undo = () => {
    commit();
    if (index.value > 0) apply(index.value - 1);
  };
  const redo = () => {
    commit();
    if (index.value < entries.value.length - 1) apply(index.value + 1);
  };
  const edit = action => {
    commit();
    action();
    commit();
  };
  const begin = () => {
    commit();
    grouping = true;
  };
  const end = () => {
    grouping = false;
    commit();
  };
  onBeforeUnmount(() => clearTimeout(timer));
  return {
    edit,
    undo,
    redo,
    commit,
    begin,
    end,
    canUndo: computed(
      () => index.value > 0 || read() !== entries.value[index.value]
    ),
    canRedo: computed(
      () =>
        index.value < entries.value.length - 1 &&
        read() === entries.value[index.value]
    ),
  };
};
